// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".YUIg4DvXGFJSvMprANDB.ant-flex {\n\tpadding-top: 25px;\n}\n\n.BdU_hPoBdINpJcY8NF0_.ant-alert-with-description {\n\tpadding: 10px;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/estimates/details/components/styles/LinkContractEstimateModal.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd","sourcesContent":[".container:global(.ant-flex) {\n\tpadding-top: 25px;\n}\n\n.alert:global(.ant-alert-with-description) {\n\tpadding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "YUIg4DvXGFJSvMprANDB",
	"alert": "BdU_hPoBdINpJcY8NF0_"
};
export default ___CSS_LOADER_EXPORT___;
